<template>
  <v-select v-bind="$attrs" v-on="$listeners" :items="items" />
</template>

<script>
export default {
  name: 'CoverageAreaSelect',

  data: () =>({
    items: [ 10, 20, 30, 40, 50, 60, 70, 80, 90, 100 ]
  }),
}
</script>